import { httpGet } from "@/utils/http";
import Storage from "good-storage";
import { randString } from "@/utils/libs";
import { useUserStoreWithOut } from '@/store/modules/user'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { CACHE_KEY, useCache } from '@/hooks/web/useCache'

const { wsCache } = useCache()

const userDataKey = "USER_INFO_CACHE_KEY"
const adminDataKey = "ADMIN_INFO_CACHE_KEY"
const systemInfoKey = "SYSTEM_INFO_CACHE_KEY"
const licenseInfoKey = "LICENSE_INFO_CACHE_KEY"
export function checkSession() {
  return new Promise((resolve, reject) => {
    // httpGet('/system/user/get').then(res => {
    //   resolve(res.data)
    // }).catch(e => {
    //   Storage.remove(userDataKey)
    //   reject(e)
    // })
    const userStore = useUserStoreWithOut()
    if (!userStore.getIsSetUser) {
      userStore.setUserInfoAction().then(() => {
          resolve(userStore.user)
        }).catch(e => {
          Storage.remove(userDataKey)
          reject(e)
        })
    }else {
      resolve(userStore.user)
    }
  })
}
export function checkAdminSession() {
  const item = Storage.get(adminDataKey) ?? { expire: 0, data: null }
  if (item.expire > Date.now()) {
    return Promise.resolve(item.data)
  }
  return new Promise((resolve, reject) => {
    httpGet('/api/admin/session').then(res => {
      item.data = res.data
      item.expire = Date.now() + 1000 * 30
      Storage.set(adminDataKey, item)
      resolve(item.data)
    }).catch(e => {
      Storage.remove(adminDataKey)
      reject(e)
    })
  })
}

export function removeAdminInfo() {
  Storage.remove(adminDataKey)
}


export function getNavMenuInfo() {
  const items = [];
  const roleRouters = wsCache.get(CACHE_KEY.ROLE_ROUTERS)
  if(roleRouters){
    const aiRoutes = roleRouters.filter((item) => item.visible && item.path === '/aip')
    const menus = flatMultiLevelRoutes(aiRoutes)
    // 遍历二级菜单
    for (const menu of menus) {
      if (menu.meta?.hidden || menu.children?.length) {
        continue
      }
      const {id, name, path, icon, parentId} = menu;
      const parentPath = parentId ? roleRouters.find(item => item.id === parentId)?.path ??  '' : '';
      items.push({id, name, url: renderMenuUrl(parentPath,path), icon, enabled: true, sort_num: id})
    }
  }
  return Promise.resolve(items);
}
function flatMultiLevelRoutes(menus){
  if(menus && menus.length === 1){
    return menus[0].children
  }
  return [];
}
function renderMenuUrl(parentPath, path){
  if (parentPath.endsWith('/')) {
    parentPath = parentPath.slice(0, -1) // 移除默认的 /
  }
  if (!path.startsWith('/')) {
    path = '/' + path
  }
  return parentPath + path
}


export function getSystemInfo() {
  const item = Storage.get(systemInfoKey) ?? { expire: 0, data: null }
  if (item.expire > Date.now()) {
    return Promise.resolve(item.data)
  }
  return new Promise((resolve, reject) => {
    // httpGet('/config/get?key=system').then(res => {
    //     item.data = res
    //     item.expire = Date.now() + 1000 * 30
    //     Storage.set(systemInfoKey, item)
    //     resolve(item.data)
    // }).catch(err => {
    //     reject(err)
    // })
    const res = {
      "code": 0,
      "data": {
          "admin_title": "LEHE-AI 控制台",
          "advance_voice_power": 120,
          "bar_logo": "/images/bar_logo.png",
          "context_deep": 10,
          "copyright": "ZHIPAI-AI_2025",
          "daily_power": 1,
          "dall_power": 10,
          "email_white_list": [
              "qq.com",
              "126.com",
              "163.com",
              "gmail.com",
              "foxmail.com",
              "yahoo.com",
              "outlook.com",
              "hotmail.com"
          ],
          "enable_context": true,
          "enabled_register": true,
          "enabled_verify": false,
          "icp": "粤ICP备xxxx号",
          "index_navs": [
              1,
              5,
              13,
              9,
              8,
              12,
              16,
              17,
              10,
              19
          ],
          "init_power": 5,
          "invite_power": 5,
          "keling_powers": {
              "kling-v1-5_pro_10": 840,
              "kling-v1-5_pro_5": 420,
              "kling-v1-5_std_10": 480,
              "kling-v1-5_std_5": 240,
              "kling-v1-6_pro_10": 840,
              "kling-v1-6_pro_5": 420,
              "kling-v1-6_std_10": 480,
              "kling-v1-6_std_5": 240,
              "kling-v1_pro_10": 840,
              "kling-v1_pro_5": 420,
              "kling-v1_std_10": 240,
              "kling-v1_std_5": 120
          },
          "logo": "/static/upload/2025/1/1736135429683457.jpg",
          "luma_power": 120,
          "mark_map_text": "# ZHIPAIAI 演示站\n\n- 完整的开源系统，前端应用和后台管理系统皆可开箱即用。\n- 基于 Websocket 实现，完美的打字机体验。\n- 内置了各种预训练好的角色应用,轻松满足你的各种聊天和应用需求。\n- 支持 OPenAI，Azure，文心一言，讯飞星火，清华 ChatGLM等多个大语言模型。\n- 支持 MidJourney / Stable Diffusion AI 绘画集成，开箱即用。\n- 支持使用个人微信二维码作为充值收费的支付渠道，无需企业支付通道。\n- 已集成支付宝支付功能，微信支付，支持多种会员套餐和点卡购买功能。\n- 集成插件 API 功能，可结合大语言模型的 function 功能开发各种强大的插件。",
          "max_file_size": 10,
          "mj_action_power": 5,
          "mj_mode": "fast",
          "mj_power": 20,
          "order_pay_timeout": 1800,
          "prompt_power": 1,
          "register_ways": [
              "mobile",
              "email"
          ],
          // "sd_neg_prompt": "(worst quality:2), (low quality:2), (normal quality:2), lowres, ((monochrome)), ((grayscale)), bad anatomy,DeepNegative, skin spots, acnes, skin blemishes,(fat:1.2),facing away, looking away,tilted head, lowres,bad anatomy,bad hands, missing fingers,extra digit, fewer digits,bad feet,poorly drawn hands,poorly drawn face,mutation,deformed,extra fingers,extra limbs,extra arms,extra legs,malformed limbs,fused fingers,too many fingers,long neck,cross-eyed,mutated hands,polar lowres,bad body,bad proportions,gross proportions,missing arms,missing legs,extra digit, extra arms, extra leg, extra foot,teethcroppe,signature, watermark, username,blurry,cropped,jpeg artifacts,text,error",
          // "sd_power": 5,
          // "suno_power": 30,
          "title": "乐和",
          "translate_model_id": 1,
          // "vip_info_text": "本站点是演示站，所有的充值产品均作为展示作用，请不要充值！！！请不要充值！！！请不要充值！！！",
          // "wechat_card_url": "/images/wx.png"
      }
  }
    item.data = res
    item.expire = Date.now() + 1000 * 30
    Storage.set(systemInfoKey, item)
    resolve(item.data)
  })
}

export function getLicenseInfo() {
  const item = Storage.get(licenseInfoKey) ?? { expire: 0, data: null }
  if (item.expire > Date.now()) {
    return Promise.resolve(item.data)
  }

  return new Promise((resolve, reject) => {
    // httpGet('/api/config/license').then(res => {
    //   item.data = res
    //   item.expire = Date.now() + 1000 * 30
    //   Storage.set(licenseInfoKey, item)
    //   resolve(item.data)
    // }).catch(err => {
    //   resolve(err)
    // })
    const res = {"code":0,"data":{"user_num":10000,"de_copy":false}}
    item.data = res
    item.expire = Date.now() + 1000 * 30
    Storage.set(licenseInfoKey, item)
    resolve(item.data)
  })
}

export function getClientId() {
  let clientId = Storage.get('client_id')
  if (clientId) {
    return clientId
  }
  clientId = randString(42)
  Storage.set('client_id', clientId)
  return clientId
}
